/* eslint-disable react/display-name */
/* eslint-disable react/prop-types */
import React, { ReactNode } from 'react'


import viVN from '@hhgtech/hhg-components/i18n-values/vi-VN'

import { TranslationsProvider } from '@hhgtech/hhg-components/i18nV2'
import { useRouter } from 'next/router'

const intlValues: {
  [key: string]: Record<string, string>
} = {
  
  'vi-VN': viVN,
  
}

const englishSites = [
  'en-diabetes',
  'en-weight-management',
  'bmi-calculator-en',
]

export type Props = {
  children?: ReactNode
}

export const DynamicTranslationsWrapper = ({ children }: Props) => {
  const { locale = 'en-PH', query } = useRouter()

  const messagesLocale =
    locale === 'hi-IN' &&
    englishSites.some((site) => query?.slug?.includes(site))
      ? 'en-PH'
      : locale
  return (
    <>
      <TranslationsProvider
        locale={messagesLocale as any}
        values={intlValues[messagesLocale]}
      >
        {children}
      </TranslationsProvider>
    </>
  )
}
